import { render, staticRenderFns } from "./ClientsAdmin.vue?vue&type=template&id=08f49d5c&"
import script from "./ClientsAdmin.vue?vue&type=script&lang=js&"
export * from "./ClientsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports